"use client";

import React, { ReactNode, useRef } from "react";

const Context = React.createContext<React.RefObject<HTMLDivElement | null>>({
  current: null,
});

export const WithFilterRefContext = ({ children }: { children: ReactNode }) => {
  const filterRef = useRef<HTMLDivElement>(null);

  return <Context.Provider value={filterRef}>{children}</Context.Provider>;
};

export const useSearchPageFilterRef = () => {
  return React.useContext(Context);
};
